import { render, staticRenderFns } from "./FinancialSettings.vue?vue&type=template&id=2b7f6526"
import script from "./FinancialSettings.vue?vue&type=script&lang=js"
export * from "./FinancialSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports